import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './i18n/en/translation.json';
import translationFR from './i18n/fr/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      fr: { translation: translationFR },
    },
    lng: 'en', // langue par défaut
    fallbackLng: 'en', // langue fallback
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    returnEmptyString: false,
  });

export default i18n;
